/**
 * Currency formatting utilities.
 */

const defaultFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Format a number as currency.
 */
export function formatCurrency(amount: number, locale = 'en-US', currency = 'USD'): string {
  if (locale === 'en-US' && currency === 'USD') {
    return defaultFormatter.format(amount);
  }
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}
